import {
  InternalTransferMethodEnum,
  InternalTransferTypeEnum,
} from '@interfaces/internal-transfer/internal-transfer.interface';
import {
  AccountTypes,
  CurrentInputAccount,
  InvestmentObjectivesGetData,
  ISelectedAccount,
  Position,
  TransactionTypesEnum,
  YesNoEmpty,
} from '@interfaces/models';
import { AvgCostConversion, MinTaxConversion } from '@interfaces/models/spec-id-fallback.enum';
import { SettlementFundAoAEnum } from '@interfaces/settlement-fund/settlement-fund.enum';
import { EntityState } from '@ngrx/entity';
import { CostBasisPosition } from '@shared/services';

export interface MultiITState {
  triage: MultiITTriage;
  transferFrom: MultiITFrom;
  transferTo: MultiITTo;
  oaCollection: OACollectionState;
  mxm?: MultiITMXM;
}

export interface OACollectionState {
  currentlyCollecting: string | null;
  completedAccounts: string[];
}

export interface MultiITTriage {
  transferFrom: AccountTypes;
  transferTo: AccountTypes[];
  isDivorceTransfer?: YesNoEmpty;
}

export interface MultiITFrom {
  selectedAccount: ISelectedAccount | null;
  selectedHoldings: CostBasisPosition[];
  transferMethod: InternalTransferMethodEnum;
  transferType: InternalTransferTypeEnum;
  splitEvenly: boolean;
  avgCostConversion: AvgCostConversion;
  minTaxConversion: MinTaxConversion;
}

export interface MultiITToAccount {
  selectedAccount: CurrentInputAccount;
  positions: CostBasisPosition[];
  transactionType: TransactionTypesEnum;
  percentageOfHoldings?: string;
  transactionId: string;
  openAccount?: EntityOA;
  isGift: YesNoEmpty;
}

export interface MultiITTo extends EntityState<MultiITToAccount> {}

export interface EntityOA {
  objectives: InvestmentObjectivesGetData | null;
  settlementFund: SettlementFundAoAEnum | null;
}

export interface MultiITMXM {
  transferId?: string;
  signerState?: string;
}
